import {
  ListWcClaimsInput,
  ListWcClaimsCommand,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";

/**
 * Extended input type for listWcClaims that includes the countries parameter.
 * The backend may not yet support this field, so it is optional for forward compatibility.
 */
export interface ExtendedListWcClaimsInput extends ListWcClaimsInput {
  countries?: string[];
}

export async function listWcClaimsService(input: ExtendedListWcClaimsInput) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }
  const client = setupClaimIntakeClient(token);
  const command = new ListWcClaimsCommand(input);
  const metricsPublisher = new MetricsPublisher("api.listWcClaims");

  return await client
    .send(command)
    .then((response: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
